import Icon from '../components/Icon.vue'

Icon.register({
  tenge: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M372 160c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12h-140v228c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-228h-140c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h360zM372 32c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12h-360c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h360z'
      }
    ]
  }
})
